import { Controller } from "stimulus";

/*
 * Using the rough convention we established in `remote_partial_controller`, this should ideally be the last gasp
 * before we enact some sort of websocket-based solution for sending HTML over the wire. Since `js.erb` is deprecated,
 * we need to use JSON-formatted requests and pull the content from that. The JSON payload should look something like
 * this:
 *
 *   {
 *     "flash": { "success": "Successfully created the thing!" },
 *     "content": "<div>The thing:</div><div>Thing A</div>"
 *   }
 *
 * Your wrapping HTML should look like this:
 *
 *   <form
 *     method="post"
 *     action="things/3"
 *     data-remote="true"
 *     data-controller="ajax-content"
 *     data-action="ajax:success->ajax-content#load ajax:error->ajax-content#load"
 *   >
 *     <!-- formy form stuff -->
 *
 *     <input type="submit" value="Update">
 *   </form>
 *
 * Note that we respond to an `ajax:success` or `ajax:error` event.
 */
export default class extends Controller {
  load(e) {
    const content = e.detail[0].content;

    this.element.innerHTML = content;
  }
}
